import React from "react";
import DashboardCard from "./DashboardCard";

export default function InsightsPanel({ title, subtitle, items = [] }) {
  return (
    <DashboardCard subtitle={subtitle} title={title}>
      <div className="insight-stack">
        {items.slice(0, 4).map((item) => (
          <div key={item.title} className={`insight-item insight-item--${item.tone || "neutral"}`}>
            <div className="insight-item__top">
              <div className="insight-item__title">{item.title}</div>
              <div className="insight-item__value">{item.value}</div>
            </div>
            <div className="dashboard-muted">{item.description}</div>
          </div>
        ))}
      </div>
    </DashboardCard>
  );
}
